import React, { useState, useEffect } from 'react';
import { Pagination } from 'antd';
import type { TablePaginationConfig } from 'antd/es/table';
import './style.less';

export interface TablePaginationProps {
  pagination?: false | TablePaginationConfig;
  loading?: boolean;
  config?: any;
}

export const TablePagination: React.FC<TablePaginationProps> = ({ pagination, loading, config }) => {
  if (!pagination) return null;

  const [{ current, pageSize, total, onChange }, setPagination] = useState(pagination);
  useEffect(() => {
    setPagination(pagination);
  }, [pagination]);

  return (
    <div className="table-pagination">

      <Pagination
        size="small"
        align="end"
        current={current}
        pageSize={pageSize}
        total={total}
        showSizeChanger
        showQuickJumper
        pageSizeOptions={['20', '50', '100', '200']}
        disabled={loading}
        onChange={(page, size) => {
          setPagination(prev => ({ ...prev, current: page, pageSize: size }))
          onChange?.(page, size);
        }}
        {...config}
      />
      <div className="ml-[16px]">
        共 <span>{total}</span> 项
      </div>
    </div>
  );
};
